module.exports = __webpack_public_path__ + "static/img/icon-unknow@3x.2a869630.png";